<template>
  <div class="info-mask" v-show="revealMask" @click="hide"></div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  name: "InfoMask",
  computed: mapGetters(['revealMask']),
  methods: {
    ...mapMutations(['handleEditStatus', 'handleCurrentMenu', 'handleCurrentIcon', 'handleContainerEdit', 'handleAudioEdit']),
    hide() {
      if (this.$store.state.currentSubmenu === 'ImageStampInfo') {
        this.handleCurrentMenu('StampMenu');
        this.handleCurrentIcon('stamp');
      }
      this.handleEditStatus(false);
      this.handleContainerEdit(null);
      this.handleAudioEdit(false);
    }
  }
}
</script>

<style scoped>
.info-mask {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
</style>
